import React from 'react'
import Header from '../Header'
import Sidebar from '../SideBar/Sidebar'
import Footer from '../Footer'

const AnsAndQuest = () => {
  return (
    <div className='ans-and-quest'>
        <Header/>
        <div className="sidebar-and-quests">
            <Sidebar/>
            <div className="answers-to-questions">
                <h3>Вопросы и ответы</h3>
                <div className="quest-bar">
                    <p className='quest-1 orange-quest'>01. Как, и как долго можно хранить моцареллу?</p>
                    <p className='quest-1'>02.Почему на сыре появляется черная плесень?</p>
                    <p className='quest-1'>03.От чего у  камамбера появляется горький вкус?</p>
                    <p className='quest-1'>04.Знаю, что сычужный белок бывает одного вида, тогда каким образом изготавливаются разные виды сыра? </p>
                    <p className='quest-1'>05.Можно приготовить сыр, используя молоко не первой свежести, предварительно прокипятив его?</p>
                    <p className='quest-1'>06.Для чего используется хлористый кальций?  </p>
                    <p className='quest-1'>07.Можно приготовить сыр, используя молоко не первой свежести, предварительно прокипятив его? </p>
                    <p className='quest-1'>08.Для чего используется хлористый кальций?</p>
                </div>
                <div className="answer-bar first-ans-bar">
                    <h4 className='ans-1'>01.Как, и как долго можно хранить моцареллу?</h4>
                    <p className='ans-2'>Для хранения моцареллы нужно приготовить рассол 2%: для этого понадобится 20 грамм соли на 1 литр чистой воды, е 10 мл 10% раствора хлористого кальция, и 0,6 мл 9% уксуса. Когда рассол готов, добавьте сыр, закройте крышкой и положите в холодильник.
                        Соленую моцареллу можно хранить одну неделю, а несоленую два, три дня.</p>
                </div>
                <hr />
                <div className="answer-bar">
                    <h4 className='ans-1'>02.Почему на сыре появляется черная плесень?</h4>
                    <p className='ans-2'>Сыр покрывается черной плесенью, когда он находится внутри холодильника и рядом с сыром стоят фрукты или овощи. Необходимо класть отдельно данные продукты, но перед этим нужно почистить холодильник, чтобы внутри не осталась плесень.</p>
                </div>
                <hr />
                <div className="answer-bar">
                    <h4 className='ans-1'>03.От чего у  камамбера появляется горький вкус?</h4>
                    <p className='ans-2'>Причин много, выделяем самые популярные:
1. Плохое качество молока.
2.Возможно корове давали силос, и это изменило вкус молока.
3. Большое количество хлористого кальция добавлено.
4. Есть вероятность, что каким-то образом плесень стала влажной. </p>
                </div>
                <hr />
                <div className="answer-bar">
                    <h4 className='ans-1'>04.Знаю, что сычужный белок бывает одного вида, тогда каким образом изготавливаются разные виды сыра?</h4>
                    <p className='ans-2'>Сычужный белок является коагулянтом, он стимулирует свертывание молока и создает сырный комок.
Различаются четыре вида коагулянтов. 
1 Естественный сычужный белок
2 Вегетарианский ренин
3 Микробиальный фермент
4 Пепсин
Если вы готовите сыр с долгой выдержкой, необходимо употребить естественный сычужный белок и вегетарианский ренин.
Сычужный белок  имеет два вида: жидкий и сухой. Можно использовать и тот и другой, важно правильное использование – следуйте инструкции, которая указана на упаковке.</p>
                </div>
                <hr />
                <div className="answer-bar">
                    <h4 className='ans-1'>05.Можно приготовить сыр, используя молоко не первой свежести, предварительно прокипятив его?</h4>
                    <p className='ans-2'>Для хранения моцареллы нужно приготовить рассол 2%: для этого понадобится 20 грамм соли на 1 литр чистой воды, е 10 мл 10% раствора хлористого кальция, и 0,6 мл 9% уксуса. Когда рассол готов, добавьте сыр, закройте крышкой и положите в холодильник.
Соленую моцареллу можно хранить одну неделю, а несоленую два, три дня.</p>
                </div>
                <hr className='last-hr-in-ans-and-quest' />
            </div>
        </div>
        <Footer/>
    </div>
  )
}

export default AnsAndQuest
